module.exports = __webpack_public_path__ + "img/border8.1fd664a5.png";